import type { Session } from './api';

/**
 * 会话在本地怎么存。
 *
 * `localStorage` 而不是 cookie：这个大厅要能被塞进 webview、也可能和后端
 * 不同源，cookie 在那些情况下很难伺候（SameSite、第三方拦截）。
 * 代价是拿不到 HttpOnly —— 但**页面上本来就没有第三方脚本**，
 * 而 token 只在内存里传给 fetch，不往 URL、不往日志。
 */
const KEY = 'lobby.session';

export function loadSession(store: Pick<Storage, 'getItem'> | null): Session | null {
  try {
    const raw = store?.getItem(KEY);
    if (!raw) return null;
    const o = JSON.parse(raw) as Partial<Session>;
    // 字段不全就当没有 —— 上个版本存的形状可能不一样
    if (!o || typeof o.token !== 'string' || typeof o.uid !== 'string') return null;
    return { uid: o.uid, token: o.token, expiresAt: String(o.expiresAt ?? '') };
  } catch {
    return null;
  }
}

export function saveSession(store: Pick<Storage, 'setItem' | 'removeItem'> | null,
                            s: Session | null): void {
  try {
    if (s) store?.setItem(KEY, JSON.stringify(s));
    else store?.removeItem(KEY);
  } catch { /* 隐私模式：这次会话内仍然有效 */ }
}
